module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p14-0b63b7ec235a3ae73dbb1568e601100d.png";